import { render, staticRenderFns } from "./CardCalendar.vue?vue&type=template&id=71b54b16&"
import script from "./CardCalendar.vue?vue&type=script&lang=ts&"
export * from "./CardCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports